import { convertirFormatoHora, formatDate, texto } from '@/shared';
import { gridSizeMdLg12, gridSizeMdLg6 } from '@/shared/constants';
import RefreshIcon from '@mui/icons-material/Refresh';
import {
  FormControl,
  Grid,
  IconButton,
  Paper,
  Tooltip,
  Typography,
  styled,
} from '@mui/material';
import dayjs from 'dayjs';
import { useState } from 'react';
import { CustomConfirmDialogProps } from '@/shared/components/ui/Dialogs';
import { useFlotasStore } from '@/store/erp';
import { CustomAutocomplete } from '@/shared/components/ui';
import { Flota } from '@/shared/interfaces';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { CustomAlertCard } from '@/shared/components/ui/Alerts';
import useCalendarioInstalacionPyl from '../../store/useCalendarioInstalacionPyl.store';
import './CalendarioPreagendamientoPyl.css'

interface StyledPaperProps {
  isclicked: boolean;
}

const StyledPaper = styled(Paper)<StyledPaperProps>(({ isclicked }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '5px',
  borderRadius: '5px',
  color: isclicked ? 'white' : 'gray',
  backgroundColor: isclicked ? '#2b4c7e' : '#ffffff',
  transition: 'background-color 0.3s',
  cursor: !isclicked ? 'default' : 'pointer',
  //border: '1px solid #E0E0E0',
  border: '1px solid #ccc',
  margin: '10px 0px',
  position: 'relative', // Para posicionar el icono
}));


interface CustomPaperProps {
  id: string;
  children: React.ReactNode;
  onClick: (id: string) => void;
  isClicked: boolean;
}

const CustomPaper: React.FC<CustomPaperProps> = ({
  id,
  children,
  onClick,
  isClicked,
}) => {
  const handleClick = () => {
    onClick(id);
  };

  return (
    <StyledPaper onClick={handleClick} isclicked={isClicked}>
      {children}
    </StyledPaper>
  );
};

interface CalendarioPreagendamientoPylProps {
  form: any;
  cacheKey: string;
}

export default function CalendarioPreagendamientoPyl({ form, cacheKey }: CalendarioPreagendamientoPylProps) {

  const {
    handleRecargarHoras,
    clickedIdHora,
    setClickedIdHora,
    countdown,
    horasDisponibles,
    fechaSelecionada,
    setFechaSelecionada,
    bloquear,
    modal,
    setModal,
    fechaHoraDisponible,
    minDate,
    maxDate,
    handleVerificarHoraSeleccionada,
    handleObtenerPlanificacion,
    isLoadingPlanificacion,
  } = useCalendarioInstalacionPyl();

  const { flotasPreagendamiento, isLoadingFlotasPreagendamiento } = useFlotasStore();

  const [horaAux, setHoraAux] = useState<number | null>(null);

  return (
    <>

      <Grid item container spacing={3} paddingTop={'20px'} justifyContent={'space-between'}>

        <CustomAutocomplete<Flota>
          disabled={bloquear}
          size={gridSizeMdLg6}
          label={'Técnicos Disponibles'}
          name="flota"
          options={flotasPreagendamiento || []}
          valueKey="nombre"
          actualValueKey="codigo"
          defaultValue={form.getValues().flota}
          isLoadingData={isLoadingFlotasPreagendamiento}
          control={form.control}
          error={undefined}
          helperText={undefined}
          onChangeValue={(value) => {
            handleObtenerPlanificacion(value, form.getValues().fecha_instalacion)
          }}
        />

        {
          fechaHoraDisponible != null && form.getValues().flota && !isLoadingPlanificacion ? (
            <>
              <Grid item {...gridSizeMdLg6}>
                <FormControl fullWidth>
                  <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                    adapterLocale="es"
                  >
                    <DatePicker
                      format='YYYY-MM-DD'
                      label="Seleccionar fecha"
                      disabled={bloquear}
                      minDate={dayjs(minDate)}
                      maxDate={dayjs(maxDate)}
                      referenceDate={dayjs(new Date())}
                      value={dayjs(fechaSelecionada)}
                      onChange={e => {
                        if (e)
                          setFechaSelecionada(formatDate(e.toISOString()))
                      }
                      }
                    />
                  </LocalizationProvider>
                </FormControl>

              </Grid>

              <Grid item {...gridSizeMdLg6}>
                <img
                  src="/calendar-planificador.svg"
                  alt="select hour"
                  draggable="false"
                  style={{
                    width: '100%',
                    height: 'auto',
                    margin: 'auto',
                    objectFit: 'cover',
                  }}
                />
              </Grid>

              {horasDisponibles && horasDisponibles?.length > 0 && (
                <Grid item container {...gridSizeMdLg6}>
                  <Grid item xs={10}>
                    <Typography variant="subtitle1" sx={{ textAlign: 'start' }}>
                      Tiempo restante:
                    </Typography>
                  </Grid>

                  {clickedIdHora == null && (
                    <Grid item xs={2}>
                      <Tooltip title="Refrescar Horas" placement="top">
                        <IconButton
                          color="primary"
                          onClick={() => handleRecargarHoras()}
                        >
                          <RefreshIcon />
                        </IconButton>
                      </Tooltip>
                    </Grid>
                  )}

                  <Grid item {...gridSizeMdLg12}>
                    <Paper
                      elevation={1}
                      sx={{
                        borderRadius: '3px',
                        padding: '5px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        border: '1px solid #E0E0E0',
                      }}
                    >
                      <p>{`${Math.floor(countdown / 60)}:${countdown % 60
                        } minutos`}</p>
                    </Paper>
                  </Grid>

                  <Grid item {...gridSizeMdLg12}>
                    <Paper
                      sx={{
                        maxHeight: 250,
                        overflowY: 'auto',
                        margin: 'auto',
                        textAlign: 'center',
                      }}
                    >
                      {horasDisponibles?.map((e) => (
                        <CustomPaper
                          key={e.hora}
                          id={`id-${e.hora}`}
                          onClick={async () => {
                            setHoraAux(e.hora)
                            handleVerificarHoraSeleccionada(e.hora);
                          }}
                          isClicked={clickedIdHora === `id-${e.hora}`}
                        >
                          {convertirFormatoHora(e.hora)}
                        </CustomPaper>
                      ))}
                    </Paper>
                  </Grid>
                </Grid>
              )}
            </>
          ) : <CustomAlertCard
            alertTitle='Información'
            alertColor='info'
            alertMessage={texto.flota_sin_planificacion}
          />
        }



      </Grid >

      {/* Modal de confirmar hora */}
      {
        <CustomConfirmDialogProps
          open={modal}
          title="Seleccionar horario de instalación"
          subtitle="¿Está seguro de querer agendar la instalacion en este horario?"
          text2={texto.mensaje_bloquar_horario}
          confirmTextBtn="Si, seleccionar horario"
          onClose={() => {
            setModal(false);
            setHoraAux(null);
          }}
          onConfirm={() => {
            setClickedIdHora(`id-${horaAux}`, cacheKey)
            setModal(false)
          }}
        />
      }

    </>
  )
}
